import { Box, CircularProgress, Container, Divider, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import translate from "../../../i18n/translate";
import "./EmailTemplates.scss";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { LOCALES } from "../../../i18n/locales";
import INTLProvider from "../../../i18n/provider";
import NoDataFound from "../../shared/NoDataFoundComponent/NoDataFound";
import ProductivityToolsDescriptionContainer from "../../shared/ProductivityToolsDescriptionContainer/ProductivityToolsDescriptionContainer";

const EmailTemplates = () => {
  const [selectedLanguage, setSelectedLanguage] = useState<string>("");
  const [defaultLanguage, setDefaultLanguage] = useState<boolean>(true);
  const [availableLanguages, setAvailableLanguages] = useState<IMasterJSON[]>([]);
  const [selectedLanguageDetails, setSelectedLanguageDetails] = useState<ILanguageDetails>({} as ILanguageDetails);
  const [selectedLanguageTopics, setSelectedLanguageTopics] = useState<any>([]);
  const [selectedLanguageSubTopics, setSelectedLanguageSubTopics] = useState<any>([]);
  const [selectedTopic, setSelectedTopic] = useState<number>(1);
  const [selectedSubTopic, setSelectedSubTopic] = useState<number>(11);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [newScopeDetails, setNewScopeDetails] = useState<any>();
  const [mailToUrl, setMailToUrl] = useState<any>();
  const allInfo = useSelector((state: any) => state);

  /* interface */

  interface IMasterJSON {
    title: string;
    code: string;
  }

  interface ILanguageDetails {
    category: ICategory[];
  }

  interface ICategory {
    title: string;
    id: number;
    subCategory: ISubCategory[];
  }

  interface ISubCategory {
    subTitle: string;
    subId: number;
    subject: string;
    body: string;
  }

  /* useEffect */

  useEffect(() => {
    getMasterJSON();
  }, []);

  useEffect(() => {
    if (availableLanguages.length && defaultLanguage && selectedLanguage) {
      getSelectedLanguage(selectedLanguage);
      setDefaultLanguage(false)
    }
  }, [availableLanguages, defaultLanguage, selectedLanguage]);

  useEffect(() => {
    if (Object.keys(selectedLanguageDetails).length) handleTopicChanges();
  }, [selectedLanguageDetails]);

  useEffect(() => {
    const licenses: any = allInfo?.peopleInformation?.data?.getpeopleInformation?.license;
    if (licenses?.length){
      const productLanguage = licenses[0].productName?.split(" ")[2]?.toUpperCase() || "ENGLISH";
      const allLanguagesCodes: any = {...LOCALES};
      let languageCode: any = allLanguagesCodes[productLanguage] || "EN-EN";
      languageCode = languageCode === "ES-ES" ? "ES-MX" : languageCode;
      setSelectedLanguage(languageCode);
    }
  },[allInfo.peopleInformation])

  useEffect(() => {
      getTemplateDetails()
  }, [selectedSubTopic, selectedLanguageSubTopics]);

  /* Api calls */

  const getMasterJSON = async () => {
    const response = await axios.get(`${process.env.REACT_APP_ASSETS_URL}/halo/emailTemplates/Master.json`);
    if (response?.data?.languages) setAvailableLanguages(response.data.languages);
  };

  const getSelectedLanguage = async (languageCode: string) => {
    const response = await axios.get(`${process.env.REACT_APP_ASSETS_URL}/halo/emailTemplates/${languageCode === "EN" ? "EN-EN" : languageCode}.json`);
    if (response?.data?.category?.length) setSelectedLanguageDetails(response.data);
  };

  /* handle change events */

  const handleTopicChanges = () => {
    const topLevelTopics = selectedLanguageDetails.category.map(({ title, id }: ICategory) => {
      return { title, id };
    });
    setSelectedLanguageTopics(topLevelTopics);
    handleSubTopicChanges(selectedTopic);
  };

  const handleSubTopicChanges = (selectedTopicId: number) => {
    selectedLanguageDetails.category.forEach(({ subCategory, id }: ICategory) => {
      if (id === selectedTopicId) {
        setSelectedSubTopic(subCategory[0].subId);
        setSelectedLanguageSubTopics(subCategory);
      }
    });
    setIsLoading(false);
  };

  const handleChangeOfLanguage = (event: any) => {
    setIsLoading(true);
    setSelectedTopic(1);
    const languageCode = event.target.value === "EN" ? "EN-EN" : event.target.value;
    setSelectedLanguage(languageCode);
    getSelectedLanguage(languageCode);
  };

  /* data format methods */

  const refineText = (originalStr: string, findStr: string, replaceWithStr: string) => {
    const find = findStr;
    const re = new RegExp(find, "g");
    return originalStr.replace(re, replaceWithStr);
  };

  const getTemplateDetails = () => {
    const currentScopeDetails = selectedLanguageSubTopics.filter(
      (eachSubTopic: ISubCategory) => eachSubTopic.subId === selectedSubTopic
    );

    let mailToUrl = "";
    if (currentScopeDetails.length > 0) {
      let purifyString = refineText(currentScopeDetails[0].body, "<p>", "");
      purifyString = refineText(purifyString, "</p>", "");
      purifyString = refineText(purifyString, "<br>", "");
      purifyString = refineText(purifyString, "<div>", "");
      purifyString = refineText(purifyString, "</div>", "");
      mailToUrl = `mailto:?to=[EmailID]&subject=${encodeURI(currentScopeDetails[0].subject)}&body=${encodeURI(
        `${purifyString}`
      )}`;
      setMailToUrl(mailToUrl)
      setNewScopeDetails(currentScopeDetails);
    }
  };

  return (
    
      <div className="emailtemplate">
        <Container>
        { selectedLanguage ?
          <React.Fragment>
            <ProductivityToolsDescriptionContainer
              headingTitle = "feature_emailTemplates_title"
              featureDescription = "Blob"
              featureImg = {window.location.origin + "/images/" + "Feature_Illustrations/Email-templates.svg"}
            />
            <div className="emailtemplate-content">
              <div className="emailtemplate-content-left">
                <div className="emailtemplate-content-box">
                  <FormControl variant="outlined" className="custom-language-picker">
                    <InputLabel id="LanguageLabel" className="custom-language-dropdown-label">
                      {translate("SAA")}
                    </InputLabel>
                    <Select
                      labelId="LanguageLabel"
                      id="language"
                      value={selectedLanguage === "EN" ? "EN-EN" : selectedLanguage}
                      onChange={handleChangeOfLanguage}
                      label={translate("languageSelect")}
                      className="custom-language-dropdown-select-layer"
                    >
                      {availableLanguages && availableLanguages.length > 0 ? (
                        availableLanguages.map((eachAvailableLanguage) => (
                          <MenuItem key={eachAvailableLanguage.code} value={eachAvailableLanguage.code}>{eachAvailableLanguage.title}</MenuItem>
                        ))
                      ) : (
                        <MenuItem>
                        {translate("languageSelect")}
                        </MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </div>
                <div className="emailtemplate-content-box">
                  <FormControl variant="outlined" className="custom-topic-dropdown">
                    <InputLabel id="CategoryLabel" className="custom-topic-dropdown-label">
                      {translate("SelectACategory")}
                    </InputLabel>
                    <Select
                      labelId="CategoryLabel"
                      id="category"
                      value={selectedTopic}
                      onChange={(e) => {
                        setSelectedTopic(Number(e.target.value));
                        handleSubTopicChanges(Number(e.target.value));
                      }}
                      label={translate("SelectACategory")}
                      className="custom-topic-dropdown-select-layer"
                    >
                      { 
                        selectedLanguageTopics?.map((value: any) => (
                          <MenuItem key={value.id} value={value.id} className="custom-topic-dropdown-menu-item">
                            <INTLProvider locale={selectedLanguage === "EN-EN" ? "EN" : selectedLanguage}>{translate(`${value.title}`)}</INTLProvider>
                          </MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>
                </div>
                <div className="emailtemplate-content-box">
                  <FormControl variant="outlined" className="custom-subtopic-dropdown">
                    <InputLabel id="TopicLabel" className="custom-subtopic-dropdown-label">
                      {translate("SAT")}
                    </InputLabel>
                    <Select
                      labelId="TopicLabel"
                      id="topic"
                      value={selectedSubTopic}
                      onChange={(e) => setSelectedSubTopic(Number(e.target.value))}
                      label={translate("SAT")}
                      className="custom-subtopic-dropdown-select-layer"
                    >
                      {
                        selectedLanguageSubTopics?.map((subValue: any) => (
                          <MenuItem key={subValue.subId} value={subValue.subId} className="custom-subtopic-dropdown-menu-item">
                            <INTLProvider locale={selectedLanguage === "EN-EN" ? "EN" : selectedLanguage}>{translate(`${subValue.subTitle}`)}</INTLProvider>
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </div>
                <INTLProvider locale={selectedLanguage === "EN-EN" ? "EN" : selectedLanguage}>
                  <Box className="emailtemplate-content-quote">
                    <p className="margin30"><i>"{translate("Quote1")}"</i> {translate("Quote1By")}</p>
                    <p><i>"{translate("Quote2")}" </i> {translate("Quote2By")}</p>
                    <p><i>"{translate("Quote3")}" </i> {translate("Quote3By")}{" "}</p>
                  </Box>
                </INTLProvider>
              </div>
              <div className="emailtemplate-content-right">
                { !isLoading ?
                  <React.Fragment>
                    {  newScopeDetails?.[0].subject && newScopeDetails?.[0].body ?
                      <React.Fragment>
                        <div className="emailtemplate-content-right-header">
                          <div className="emailtemplate-subject">{newScopeDetails[0].subject}</div>
                          <Link
                            to="#"
                            className="emailtemplate-button"
                            onClick={(e) => {
                              window.location.href = mailToUrl;
                              e.preventDefault();
                            }}
                          >
                            {translate("OpenInEmail")}
                          </Link>
                        </div>
                        <Divider />
                        <div className="emailtemplate-description" dangerouslySetInnerHTML={{ __html: newScopeDetails[0].body }} />
                      </React.Fragment>
                      :
                      <NoDataFound />
                    }
                  </React.Fragment>
                  :
                  <div className="emailtemplate-loader top-40">
                    <CircularProgress size={50} color="primary" />
                  </div>
                }
              </div>
            </div>
          </React.Fragment>
        :
          <div className="emailtemplate-loader">
            <CircularProgress size={50} color="primary" />
          </div>
        }
        </Container>
      </div>
   
  );
};

export default EmailTemplates;